module.exports = __webpack_public_path__ + "img/ImagePlaceholder.76005957.svg";